import React from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {SzBox, SzButton, SzDatePicker, SzIcon, SzInput, SzModal, SzPagination, SzSelect, SzTab, SzTypographie} from "@suezenv/react-theme-components";
import {mapAction} from "../../map/store/actions";
import AlarmSolvedRow from "../components/Alarm/AlarmSolvedRow";
import AlarmRow from "../components/Alarm/AlarmRow";
import EmptyRow from "../components/utils/EmptyRow";
import AlarmService from "../services/AlarmService";
import LocationReferenceService from "../../main/services/LocationReferenceService";
import {alarmAction} from "../store/actions";
import {
    PAGINATION_CURRENT_PAGE,
    PAGINATION_PAGE_COUNT, PAGINATION_PER_PAGE,
    PAGINATION_TOTAL_COUNT,
    RAISED_STATUS,
    SOLVED_STATUS,
    ENCODING_CSV_UTF8
} from "../../main/store/constants";
import EquipmentService from "../services/EquipmentService";
import AcknowledgeAlarm from "../components/Alarm/AcknowledgeAlarm";
import AlertBox, { AlertBoxType } from "../../ui/alert/AlertBox";
import * as services from "../../services/services";
import {routesPath} from "../../routes";
import {withRouter} from "react-router";

const FIRST_PAGE = 1;
const PAGINATION_PAGE_RANGE_MAX = 10;
const DEFAULT_ITEMS_PER_PAGE: number = 20;
const DEFAULT_SORT_KEY: string = 'date';
const DEFAULT_SORT_DIR: string = 'desc';

interface ISelectOption {
    value: string|undefined;
    label: string|undefined;
}

interface IFilter {
    startAt: Date|null,
    endAt: Date|null,
    alarmAcked: ISelectOption,
    alarmTypes: ISelectOption[],
    search: string,
}

class AlarmManager extends React.Component<any> {

    public state: { 
        tab: string,
        sort: any,
        filter: IFilter,
        alarmTypes: [],
        raisedAlarmsPage: number,
        solvedAlarmsPage: number,
        itemsPerPage: string,
        selectAllAlarms: boolean,
        selectedAlarms: Set<string>
        showAcknowledgeAlarmModal: boolean,
        alert: AlertBoxType|null
    } = {
        tab: "tab-0",
        sort: {
            RAISED: {field: "startAt", dir: "desc"},
            SOLVED: {field: "startAt", dir: "desc"},
        },
        filter: {
            startAt: null,
            endAt: null,
            alarmAcked: { value: undefined, label: undefined },
            alarmTypes: [],
            search: this.props.filters.query,
        },
        raisedAlarmsPage: FIRST_PAGE,
        solvedAlarmsPage: FIRST_PAGE,
        itemsPerPage: "20",
        alarmTypes: [],
        selectAllAlarms: false,
        selectedAlarms: new Set(),
        showAcknowledgeAlarmModal: false,
        alert: null
    };

    public componentDidMount() {
        this.loadAlarmTypes();
        this.initTable();
    }

    public acknowledgeAlarmConfirmHandler(user: any) {
        const ackUserId = user.id;
        const ackUserName = (!user.firstName && !user.lastName) ? user.email : `${user.firstName} ${user.lastName}`;
        const alarms = Array.from(this.state.selectedAlarms);

        AlarmService.acknowledgeAlarms(ackUserId, ackUserName, alarms)
            .then(response => {
                const alert = { type: 'success', message: services.useExtractResponseMessage(this.props.t, response) };
                this.setState({alert: alert})

                this.updateAlarmData(FIRST_PAGE, RAISED_STATUS);
                this.updateAlarmData(FIRST_PAGE, SOLVED_STATUS);
            })
            .catch(error => {
                const alert = { type: 'danger', message: services.useExtractResponseMessage(this.props.t, error) };
                this.setState({alert: alert})
            });
    }

    public commentSubmitHandler(alarm: any, comment: string = "", filter = {status: null, locationReferences: [], functionalType: null, types: []}) {
        AlarmService.updateAlarm(alarm.id, {comment})
            .then(response => {
                const alert = { type: 'success', message: services.useExtractResponseMessage(this.props.t, response) };
                this.setState({alert: alert})

                let filters: any = { locationReferences: [], query: '' };
                filters = this.mergeStateFilters(filters);
                this.updateAlarmData(FIRST_PAGE, RAISED_STATUS, "startAt", "desc", filters);
                this.updateAlarmData(FIRST_PAGE, SOLVED_STATUS, "startAt", "desc", filters);

            })
            .catch(error => {
                const alert = { type: 'danger', message: services.useExtractResponseMessage(this.props.t, error) };
                this.setState({alert: alert})
            });
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const filterChanged =
            prevState.filter.startAt !== this.state.filter.startAt ||
            prevState.filter.endAt !== this.state.filter.endAt ||
            prevState.filter.alarmAcked !== this.state.filter.alarmAcked ||
            prevState.filter.alarmTypes.length !== this.state.filter.alarmTypes.length;
        
        const paginationChanged = prevState.itemsPerPage !== this.state.itemsPerPage;
        const pageChanged = prevState.raisedAlarmsPage !== this.state.raisedAlarmsPage || prevState.solvedAlarmsPage !== this.state.solvedAlarmsPage;
    
        // Reset page when filter or pagination settings change
        if (filterChanged || paginationChanged) {
            this.setState({ raisedAlarmsPage: FIRST_PAGE, solvedAlarmsPage: FIRST_PAGE }, this.submitHandle);
        } else if (pageChanged) {
            this.submitHandle();
        }
    }

    public initTable() {
        const { filters } = this.props;
        if (filters.locationReferences && filters.locationReferences.length > 0) {
            this.updateAlarmData(FIRST_PAGE, RAISED_STATUS, "startAt", "desc", filters);
            this.updateAlarmData(FIRST_PAGE, SOLVED_STATUS, "startAt", "desc", filters);
        } else {
            this.updateAlarmData(FIRST_PAGE, RAISED_STATUS);
            this.updateAlarmData(FIRST_PAGE, SOLVED_STATUS);
        }
    }

    public loadAlarmTypes() {
        AlarmService.getAlarmTypes().then((response: any) => {
            this.setState({alarmTypes: response.data});
        });
    }

    private getListEquipmentsId(data:any)
    {
        const equipmentsId:any = [];
        data.forEach((alarm:any)=>{
            equipmentsId.push(alarm.equipmentId);
        });

        return equipmentsId;
    }

    private getNotAckedAlarmIds(data: any)
    {
        const ids: string[] = [];
        Object.keys(data).forEach((key: any) => {
            const alarm = data[key];
            if (!alarm.acked) {
                ids.push(alarm.id);
            }
        });

        return ids;
    }

    private getAlarmEquipment(alarm: any, equipmentId: any)
    {
        if(!('equipments' in alarm)) {
            return null;
        }

        return alarm.equipments.find((equipement: any) => equipement.id === equipmentId);
    }

    public updateAlarmData(page = FIRST_PAGE, status: string, sort = "startAt", dir = "desc", filter = [], itemsPerPage="20") {
        
        let filters = {...this.props.filters, ...filter, status};

        AlarmService.getAlarms(page, filters, sort, dir, itemsPerPage).then((response:any) => {
            if (status === RAISED_STATUS) {
                const equipments:any =  this.getListEquipmentsId(response.data);
                EquipmentService.getEquipments(1, {
                    equipment: equipments,
                    status: null,
                    locationReferences: [],
                    query: ""
                }, null, "status_state_changed_at", "desc", parseInt(itemsPerPage)).then((equipmentResponse: any) => {
                    this.props.setAlarmsRaisedList({...response, equipments:equipmentResponse.data});
                });
                AlarmService.countAlarms(filters).then((response: any) => {
                    this.props.setAlarmsRaisedCount(response.count);
                });
            } 
            else if (status === SOLVED_STATUS) {
                const equipments:any =  this.getListEquipmentsId(response.data);
                EquipmentService.getEquipments(1, {
                    equipment: equipments,
                    status: null,
                    locationReferences: [],
                    query: ""
                }, null, "status_state_changed_at", "desc", parseInt(itemsPerPage)).then((equipmentResponse: any) => {
                        this.props.setAlarmsSolvedList({...response, equipments:equipmentResponse.data});
                });
                AlarmService.countAlarms(filters).then((response: any) => {
                    this.props.setAlarmsSolvedCount(response.count);
                });
            }

        }).catch((err) => {
            console.error(services.useExtractResponseMessage(this.props.t, err));
        });
    }

    public downloadListAlarms(status: string, sort = "startAt", dir = "desc", filter= []) {
        let filters = {...this.props.filters, ...filter, status};
        filters = this.mergeStateFilters(filters);

        const windowUrl = window.URL;
        const link = document.createElement("a");

        const fileName = this.props.t((`alarm:alarms_${status}`).toLowerCase());
        link.setAttribute("download", `${fileName}.csv`);

        AlarmService.getAlarms(FIRST_PAGE, filters, sort, dir, "all", "csv").then((response: any) => {
            const bom = new Uint8Array(ENCODING_CSV_UTF8);
            const blob = new Blob([bom, response.data], { type: 'text/csv;charset=utf-8;' });
            const url = windowUrl.createObjectURL(blob);
            link.href = url;
            document.body.appendChild(link);
            link.click();
        });
    }

    public selectTabHandle(tab = null) {
        this.setState({tab});
    }

    public renderPaginationList(status: string, listAlarms: any) {
        {
            return <>
                {listAlarms.pagination[PAGINATION_PAGE_COUNT] > 1 &&
                <div className="list-table row m-2">
                    <div className="row w-100">
                        <div className="col-6 w-100 offset-5">
                            <SzPagination
                                totalItemsCount={parseInt(listAlarms.pagination[PAGINATION_TOTAL_COUNT], 10)}
                                activePage={parseInt(listAlarms.pagination[PAGINATION_CURRENT_PAGE], 10)}
                                onChange={(pageNumber: any) => {
                                    if(status === RAISED_STATUS) {
                                        this.setState({ raisedAlarmsPage: pageNumber });
                                    } else if(status === SOLVED_STATUS) {
                                        this.setState({ solvedAlarmsPage: pageNumber });
                                    }
                                }}
                                itemsCountPerPage={parseInt(listAlarms.pagination[PAGINATION_PER_PAGE], 10)}
                                pageRangeDisplayed={PAGINATION_PAGE_RANGE_MAX}
                            />
                        </div>
                    </div>
                </div>
                }
            </>;
        }
    }

    public sortHandle(field: string, status: string) {
        const dir = (this.state.sort[status].field !== field) ? "desc" : (this.state.sort[status].dir === "desc" ? "asc" : "desc");
        this.updateAlarmData(FIRST_PAGE, status, field, dir);
        this.setState({sort: {...this.state.sort, [status]: {field, dir}}});
    }

    public renderColumnHeader(field: string, className: string, status: string = RAISED_STATUS, sortable=true) {
        return (
            <div className={`row ${className} alarm-table-header-cell`} onClick={() => this.sortHandle(field, status)}>
                <SzTypographie className="">{this.props.t(`alarm:titles.${field}`)}</SzTypographie>
                {
                    sortable && (
                        <SzIcon 
                            variant="line"
                            className="alarm-sort-icon"
                            icon={field !== this.state.sort[status].field ? "move-expand-vertical" : (this.state.sort[status].dir === "desc" ? "arrow-rectangle-down" : "arrow-rectangle-up")}
                        />
                    )
                }
            </div>
        );
    }

    public enterKeyHandle(event: any) {
        if (event.key === "Enter") {
            this.submitHandle();
        }
    }

    public resetHandle() {
        this.props.filterLocationReference({ids: [], query: "", locationReferences: []});
        const filters: any = {
            locationReferences: [],
        };
        this.updateAlarmData(FIRST_PAGE, RAISED_STATUS, "startAt", "desc", filters);
        this.updateAlarmData(FIRST_PAGE, SOLVED_STATUS, "startAt", "desc", filters);
        this.resetAll();
    }

    resetAll =() => {
        this.resetFilter();
        this.resetSelectedAlarms();
        this.resetAlert();
    }

    public submitHandle() {
        this.resetSelectedAlarms();
        this.resetAlert();

        const {search} = this.state.filter;
        if(search === "") {
            this.applyFilter();
        }
        else {
            LocationReferenceService.getLocationReferences(search).then((response: any) => {
                const localReferencesId = (response.data.length === 0 && search) ? ["notFoundLocationReferences"] : response.data;
                this.applyFilter(search, localReferencesId);
            });
        }
    }

    getAlarmTypeOptions() {
        let options = Object.keys(this.state.alarmTypes).map((key: any) => {
            const type: any = this.state.alarmTypes[key];
            return {value: key, label: type.prefixedLabel}
        });

        // sort alphabetically 
        options.sort((a, b) => {
            if (a.label < b.label) { return -1; }
            if (a.label > b.label) { return 1; }
            return 0;
        });

        return options;
    }

    getAlarmStatusOptions() {
        return [
            {value: "alarmAcked", label: this.props.t("alarm:list.alarmAcked") },
            {value: "alarmNotAcked", label: this.props.t("alarm:list.alarmNotAcked")}
        ];
    }
    
    getItemPerPageOptions() {
        return (
            <>
                <option value={20}>{20}</option>
                <option value={50}>{50}</option>
                <option value={100}>{100}</option>
            </>
        );
    }

    applyFilter(search: string = "", localReferencesId: [] = []) {
        let filters: any = { locationReferences: localReferencesId, query: '' };
        filters = this.mergeStateFilters(filters);

        this.props.filterLocationReference({ids: filters.locationReferences, query: search});
        this.updateAlarmData(this.state.raisedAlarmsPage, RAISED_STATUS, "startAt", "desc", filters, this.state.itemsPerPage);
        this.updateAlarmData(this.state.solvedAlarmsPage, SOLVED_STATUS, "startAt", "desc", filters, this.state.itemsPerPage);
    }

    mergeStateFilters(filters: any) {
        if (this.state.filter.alarmAcked?.value !== undefined) {
            filters = {...filters, acked: this.state.filter.alarmAcked.value === 'alarmAcked' ? true : false};
        }
        if (this.state.filter.alarmTypes.length) {
            const types = this.state.filter.alarmTypes.map((alarmType: any) => alarmType.value);
            filters = {...filters, types: types};
        }
        if (this.state.filter.startAt) {
            filters = {...filters, startAt: this.state.filter.startAt.toISOString()};
        }
        if (this.state.filter.endAt) {
            filters = {...filters, endAt: this.state.filter.endAt.toISOString()};
        }

        return filters;
    }

    public updateFilter(obj: object) {
        this.setState({filter: {...this.state.filter, ...obj}});
        this.resetAlert();
        // do not reset selected alarms if search is updated
        if(!('search' in obj)) {
            this.resetSelectedAlarms();
        }
    }

    hasFilter() {
        if(this.state.filter.startAt)           { return true; }
        if(this.state.filter.endAt)             { return true; }
        if(this.state.filter.alarmAcked?.value) { return true; }
        if(this.state.filter.alarmTypes.length) { return true; }
        if(this.state.filter.search)            { return true; }
        return false;
    }

    resetFilter() {
        this.setState({
            filter: {            
                startAt: null,
                endAt: null,
                alarmAcked: { value: undefined, label: undefined },
                alarmTypes: [],
                search: "",
            }
        });
    }
    
    alarmSelectHandler = (alarmId: string) => {
        const selectedAlarms = new Set(this.state.selectedAlarms);
        if (selectedAlarms.has(alarmId)) {
            selectedAlarms.delete(alarmId);
        } else {
            selectedAlarms.add(alarmId);
        }

        this.setState({selectedAlarms: selectedAlarms});
    };

    alarmSelectAllHandler = (alarms: any) => {
        const alarmIds = this.state.selectAllAlarms === true ? null : this.getNotAckedAlarmIds(alarms);

        this.setState({selectedAlarms: new Set(alarmIds)});
        this.setState({selectAllAlarms: !this.state.selectAllAlarms});
    }

    resetSelectedAlarms = () => {
        this.setState({selectAllAlarms: false});
        this.setState({selectedAlarms: new Set()});
    }

    resetAlert = () => {
        this.setState({alert: null})
    }

    onClickEventDisplayHandler = (alarm: any, equipment: any) => {
        const urlParams: string|string[] = [];
        urlParams.push(`page=${FIRST_PAGE}`);
        urlParams.push(`itemsPerPage=${DEFAULT_ITEMS_PER_PAGE}`);
        urlParams.push(`sortKey=${DEFAULT_SORT_KEY}`);
        urlParams.push(`sortDir=${DEFAULT_SORT_DIR}`);
        urlParams.push(`startAt=${(new Date(alarm.startAt)).toISOString()}`);
        urlParams.push(`endAt=${(new Date()).toISOString()}`);
        urlParams.push(`equipmentId=${equipment.id}`);
        this.props.history.push(`${routesPath.event}?${urlParams.join('&')}`);
    }

    
    onChangeAlarmTypeKeysHandler = (options: any) => {
        this.updateFilter({ alarmTypes: [] });
        if(options) {
            this.updateFilter({ alarmTypes: options });
        }
    }

    public render() {
        const {listRaisedAlarms, listSolvedAlarms, user, t, filterMapLocationReference} = this.props;

        return (
            <>
                <SzModal title={""} show={this.state.showAcknowledgeAlarmModal} handleClose={() => this.setState({showAcknowledgeAlarmModal: false})} size={"lg"}>
                    <AcknowledgeAlarm
                        closeHandle={() => this.setState({showAcknowledgeAlarmModal: false})}
                        acknowledgeAlarmConfirmHandler={this.acknowledgeAlarmConfirmHandler.bind(this)}
                        user={user}
                    />
                </SzModal>
                { 
                    this.state.alert && 
                    <div className="row ml-0 mr-4">
                        <AlertBox {...this.state.alert} />
                    </div>
                }
                <SzBox className="row alarm-title-box" tag="div">
                    <div className="row mb-1">
                        <div className="row col-6 p-0">
                            <div className="ml-2">
                                <SzIcon variant="line" icon="alarm-bell" />
                            </div>
                            <div className="col-md-4">
                                <SzTypographie color="inactive" variant="caption" className="m-0">{this.props.t("alarm:btn.alarm_text1")}</SzTypographie>
                                <SzTypographie>{this.props.t("alarm:btn.alarm_text2")}</SzTypographie>
                            </div> 
                        </div>

                        <div className="row col-6 left-block">
                            <div className="col-7">
                                <SzInput
                                    value={this.state.filter.search}
                                    onKeyUp={this.enterKeyHandle.bind(this)}
                                    onChange={({ target }) => this.updateFilter({ search: target.value })}
                                    placeholder={t("equipment:select_location_reference2")}
                                />
                            </div>
                            <div className="col-1 ">
                                <SzButton
                                    onClick={() => this.submitHandle()}
                                    variant="secondary"
                                    icon="search"
                                />
                            </div>
                            {this.hasFilter() &&
                            < div className="col-1">
                                <SzButton onClick={this.resetHandle.bind(this)} variant="secondary" icon="diagram-round"/>
                            </div>
                            }
                            <div className="col-3 alarm-items-per-page">
                                <label>Nbr résultats</label>
                                <select className="" onChange={(e) => this.setState({ itemsPerPage: e.target.value })} value={this.state.itemsPerPage}>
                                    {this.getItemPerPageOptions()}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4 alarm-date-range-picker">
                            <SzDatePicker
                                startDate={this.state.filter.startAt!}
                                endDate={this.state.filter.endAt!}
                                dateRange={true}
                                onChangeStartDate={(date) => this.updateFilter({ startAt: date })}
                                onChangeEndDate={(date) => this.updateFilter({ endAt: date })}
                            />
                            {
                                (this.state.filter.startAt || this.state.filter.endAt) && (
                                <div className="col-auto p-0 ml-4" onClick={() => this.updateFilter({startAt: null, endAt: null})}>
                                    <SzIcon variant="line" icon="remove" />
                                </div>
                                )
                            }
                        </div>
                        <div className="col-2">
                            <SzSelect
                                className="my-class"
                                onChange={(option:{value:string}) => this.updateFilter({ alarmAcked: option })}
                                placeholder={t("alarm:filter.alarmState")}
                                options={this.getAlarmStatusOptions()}
                                isClearable={true}
                                value={this.state.filter.alarmAcked?.value ? this.state.filter.alarmAcked : null}
                            />
                        </div>
                        <div className="col-3">
                            <SzSelect
                                placeholder={t("alarm:filter.alarmType")}
                                options={this.getAlarmTypeOptions()}
                                value={this.state.filter.alarmTypes}
                                onChange={(option: any) => this.onChangeAlarmTypeKeysHandler(option)}
                                isSearchable={true}
                                isMulti={true}
                            />
                        </div>
                    </div>
                </SzBox>

                <SzBox className="row alarm-tab-container position-relative mr-4">
                    <div className="alarm-tab w-100 p-0">
                        <SzTab activeKey={this.state.tab} id="story-tab" selectTabHandle={this.selectTabHandle.bind(this)} className="alarm-tab-content">
                            <SzTab.SzTabContent
                                className="alarm-tab-content"
                                eventKey="tab-0"
                                title={
                                    <div className="alarm-info-tab">
                                        <span className="alarm-info-nbr">{listRaisedAlarms.nbr.toLocaleString()}</span>
                                        <span className="alarm-info-title">{this.props.t("alarm:btn.tab_0")}</span>
                                    </div>
                                }
                            >
                                <SzBox className="row alarm-table-header">
                                    <div className="row col-3 border-right">
                                        {this.renderColumnHeader("startAt", "col-5", RAISED_STATUS)}
                                        {this.renderColumnHeader("acked", "col-3", RAISED_STATUS, false)}
                                        {this.renderColumnHeader("type", "col-4", RAISED_STATUS, false)}
                                    </div>
                                    <div className="row col-6 border-right">
                                        {this.renderColumnHeader("locationReferenceName", "col-3", RAISED_STATUS, false)}
                                        {this.renderColumnHeader("equipmentName", "col-6", RAISED_STATUS, false)}
                                        {this.renderColumnHeader("description", "col-3", RAISED_STATUS, false)}
                                    </div>
                                    <div className="row col-2 border-right">
                                        {this.renderColumnHeader("ackUserName", "col-6", RAISED_STATUS)}
                                        {this.renderColumnHeader("ackedAt", "col-6", RAISED_STATUS)}
                                    </div>
                                    <div className="row col-1">
                                        <div className="alarm-checkbox-container">
                                            <SzButton 
                                                className="mb-2 alarm-acknowledge-btn" 
                                                variant="secondary"
                                                isDisabled={this.state.selectedAlarms.size === 0 ? true : false}
                                                onClick={() => this.setState({showAcknowledgeAlarmModal: true})}
                                            >
                                                {t('alarm:acknowledge')}
                                            </SzButton>
                                            <span className="label">{t('alarm:titles.selectAll')}</span>
                                            <label className="alarm-checkbox">
                                                <input type="checkbox" checked={this.state.selectAllAlarms} onChange={() => this.alarmSelectAllHandler(listRaisedAlarms.data)}/>
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </SzBox>
                                {Object.keys(listRaisedAlarms.data).length > 0 ? (
                                    Object.values(listRaisedAlarms.data).map((alarm: any) => (
                                    <AlarmRow
                                        commentSubmitHandler={this.commentSubmitHandler.bind(this)}
                                        key={alarm.id}
                                        equipment={this.getAlarmEquipment(listRaisedAlarms, alarm.equipmentId)}
                                        alarm={alarm}
                                        user={user}
                                        filter = {this.state.filter}
                                        filterMapLocationReference={filterMapLocationReference.bind(this)}
                                        alarmSelectHandler={this.alarmSelectHandler}
                                        alarmSelected={this.state.selectedAlarms.has(alarm.id)}
                                        onClickEventDisplayHandler={this.onClickEventDisplayHandler}
                                    />
                                    ))
                                ) : (
                                    <EmptyRow />
                                )}
                                {this.renderPaginationList(RAISED_STATUS, listRaisedAlarms)}
                                <div className="row alarm-table-bottom">
                                    <SzButton variant="secondary" className="mb-3 download-btn alarm-btn" icon="download-bottom" onClick={() => this.downloadListAlarms(RAISED_STATUS)}>
                                        {t("export")}
                                    </SzButton>
                                </div>
                            </SzTab.SzTabContent>
                            <SzTab.SzTabContent
                                className="alarm-tab-content"
                                eventKey="tab-1"
                                title={
                                    <div className="alarm-info-tab">
                                        <span className="alarm-info-nbr">{listSolvedAlarms.nbr.toLocaleString()}</span>
                                        <span className="alarm-info-title">{this.props.t("alarm:btn.tab_1")}</span>
                                    </div>
                                }
                            >
                                <SzBox className="row alarm-table-header">
                                    <div className="row col-3 border-right">
                                        {this.renderColumnHeader("startAt", "col-5", SOLVED_STATUS)}
                                        {this.renderColumnHeader("acked", "col-3", SOLVED_STATUS)}
                                        {this.renderColumnHeader("type", "col-4", SOLVED_STATUS)}
                                    </div>
                                    <div className="row col-5 border-right">
                                        {this.renderColumnHeader("locationReferenceName", "col-3", SOLVED_STATUS, false)}
                                        {this.renderColumnHeader("equipmentName", "col-6", SOLVED_STATUS, false)}
                                        {this.renderColumnHeader("description", "col-3", SOLVED_STATUS, false)}
                                    </div>
                                    <div className="row col-2 border-right">
                                        {this.renderColumnHeader("ackUserName", "col-6", SOLVED_STATUS)}
                                        {this.renderColumnHeader("ackedAt", "col-6", SOLVED_STATUS)}
                                    </div>
                                    <div className="row col-2">
                                        {this.renderColumnHeader("journal", "col-6", SOLVED_STATUS, false)}
                                        {this.renderColumnHeader("comment", "col-6", SOLVED_STATUS)}
                                    </div>
                                </SzBox>
                                {Object.keys(listSolvedAlarms.data).length > 0 ?
                                Object.values(listSolvedAlarms.data).map((alarm: any) => (
                                    <AlarmSolvedRow
                                        key={alarm.id}
                                        equipment={this.getAlarmEquipment(listSolvedAlarms, alarm.equipmentId)}
                                        alarm={alarm}
                                        filterMapLocationReference={filterMapLocationReference}
                                        onClickEventDisplayHandler={this.onClickEventDisplayHandler}
                                    />
                                )) : <EmptyRow /> }
                                {this.renderPaginationList(SOLVED_STATUS, listSolvedAlarms)}
                                <div className="row alarm-table-bottom">
                                    <SzButton variant="secondary" className="mb-3 download-btn alarm-btn" icon="download-bottom" onClick={() => this.downloadListAlarms(SOLVED_STATUS)}>
                                        {t("export")}
                                    </SzButton>
                                </div>
                            </SzTab.SzTabContent>
                        </SzTab>
                    </div>
                </SzBox>
            </>
        );
    }
}

const mapDispatchToProps = {
    filterLocationReference: alarmAction.filterLocationReference,
    setAlarmsRaisedList: alarmAction.setAlarmsRaisedList,
    setAlarmsRaisedCount: alarmAction.setAlarmsRaisedCount,
    filterMapLocationReference: mapAction.filterMapLocationReference,
    setAlarmsSolvedList: alarmAction.setAlarmsSolvedList,
    setAlarmsSolvedCount: alarmAction.setAlarmsSolvedCount,
};
const mapStateToProps = (state: any) => {
    return {
        listSolvedAlarms: state.alarm.listSolvedAlarms,
        listRaisedAlarms: state.alarm.listRaisedAlarms,
        filters: state.alarm.filters,
        user: state.user,

    };
};
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(AlarmManager)));
